<script setup lang="ts">
import { ref } from 'vue';
import api from '@/api';

const isOpen = ref(false);
const loading = ref(false);
const input = ref('');
const response = ref();
const method = ref({ label: 'GET', value: 'get' });

const items = [
  { label: 'GET', value: 'get' },
  { label: 'POST', value: 'post' },
  { label: 'PATCH', value: 'PATCH' },
  { label: 'DELETE', value: 'delete' },
];

async function onClick() {
  console.log('🚀 ~ file: TestApi.vue ~ line 18 ~ onClick ~ message', input.value);
  loading.value = true;

  try {
    response.value = await api({
      method: method.value.value,
      url: input.value,
    });
  } catch (error) {
    response.value = error;
  }

  loading.value = false;
}
</script>

<template>
  <v-btn
    class="api-test_btn"
    @click="isOpen = true"
    size="small"
    variant="outlined"
    icon
    color="primary"
  >
    <v-icon icon="fas fa-circle-nodes" />
  </v-btn>
  <v-dialog max-width="750px" v-model="isOpen" persistent>
    <v-card>
      <v-card-title class="pb-4 elevation-1">Test API</v-card-title>

      <v-card-text class="api-test_content">
        <v-text-field
          v-model="input"
          :loading="loading"
          @click:append="onClick"
          class="mb-2"
          type="text"
          color="primary"
          density="compact"
          label="Call API"
          append-icon="fas fa-search"
          clearable
          single-line
          hide-details
        >
          <template v-slot:prepend-inner> https://api/viktor </template>
          <template v-slot:prepend>
            <v-select
              v-model="method"
              :items="items"
              color="primary"
              variant="outlined"
              density="compact"
              item-title="label"
              item-value="value"
              label="Filter"
              hide-details
              persistent-hint
              return-object
              single-line
            ></v-select>
          </template>
        </v-text-field>

        <v-sheet class="pa-4 my-2" color="empty">
          <p class="text-body-2 mb-2">Réponse API :</p>
          <code class="api-test_code">{{ JSON.stringify(response, null, 2) }}</code>
        </v-sheet>
      </v-card-text>

      <v-card-actions class="pt-6 justify-end elevation-4">
        <v-btn variant="tonal" @click="isOpen = false">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.api-test {
  &_code {
    white-space: pre-wrap;
  }
  &_content {
    min-height: 200px;
    max-height: 600px;
    overflow-y: auto;
  }
  &_btn {
    z-index: 1000;
    position: fixed;
    bottom: 100px;
    left: 20px;
  }
}
</style>
